import { useEffect } from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { checkWindStore } from '../../../../check-wind/store'
// Still carries HuntWind classes the stand dialog uses.
import './index.scss'

// Check Wind lives on the map (component/check-wind); picking it in Tools opens it there and closes Tools.
function HuntWind({ collapseLeftToolbar }) {
  useEffect(() => {
    checkWindStore.set(true)
    collapseLeftToolbar()
  }, [])
  return null
}

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(null, mapDispatchToProps)(HuntWind)
